( function(){
  'use strict';

  angular.module('eclipseApp.checkout').controller('shipToAddressCtrl', ['$scope', 'fulfillmentOptions', '$state', 'buyService', function($scope, fulfillmentOptions, $state, buyService){

    // canada post methods
    var _anotherShippingAddress = {},
        _cableCondMessageBaseLangTag = 'global.message.shipToAddressNote',
        _cableCondMessageLangTag = _cableCondMessageBaseLangTag.concat(buyService.getCableCondition());

    if (buyService.getCableCondition()) {

      buyService.parseViewMessageForAgeOfMajority(_cableCondMessageLangTag, '[age]', buyService.getAgeOfMajority()).then(function(resp){
        $scope.shipToCableConditionAddressMessage = resp;
      });

    }

    buyService.parseViewMessageForAgeOfMajority('retail.message.shipToAddressNote', '[age]', 
      buyService.getAgeOfMajority()).then(function(resp){
        $scope.shipToAddressNote = resp;
    });


    $scope.setAddressData = function(address){
      console.log('@setAddress', address);

      $scope.addressNotFound = false;

      _anotherShippingAddress = {
        city: address.City,
        province: address.Province,
        postalCode: address.PostalCode,
        country: address.CountryName,
        streetNumber: address.Field1,
        streetName: address.Field2,
        streetType: address.Field3.toUpperCase(),
        unitNumber: address.SubBuilding,
        streetDirection: address.Field7.toUpperCase()
      };
      if (address.POBoxNumber) {
        _anotherShippingAddress.poBox = address.Line1;
      }

      $scope.fulfillmentMethods.setShippingAddress(_anotherShippingAddress);
      $scope[$state.current.name].anotherAddress = address.Label;

      $scope.$apply();
    };
    $scope.isValidAddress = function(ev){
      console.log(_anotherShippingAddress);
      if (ev.keyCode === 13 && !_anotherShippingAddress.hasOwnProperty('streetNumber')) {
      } else {
        $scope.address = null;
        $scope.addressNotFound = false;
      }
    };
    $scope.PCAError = function(){
      $scope.PCANotAvailable = true;
    };
    $scope.PCANotFound = function(){
      _.each(document.querySelectorAll('.pca .pcaautocomplete.pcatext'), function(el) {
        el.style.display = 'none';
      });
      $scope.addressNotFound = true;
      $scope.$apply();
    };
    // end canada post methods
    $scope.$parent.resetScope();

    $scope.$on('$viewContentLoaded', function(){
      // reset checkbox when switching from one tab to another
      $scope.fulfillment.agree = false;
      console.log('@shipToAddressCtrl:VIEWCONTENTLOADED');
    });
  }]);
})();
